<template>
  <div
    class="modal"
    style="display: block"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="row">
            <div class="col-sm-12">
              <span v-if="mode === modalWindowTypes.CREATE">Add new notification</span>
              <span v-if="mode === modalWindowTypes.EDIT">Edit notification</span>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>From Name</label>
                <input
                  class="form-control"
                  v-model="models.fromName"
                  type="text"
                  value=""
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>From Email</label>
                <input
                  class="form-control"
                  v-model="models.fromEmail"
                  type="email"
                  value=""
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-9">
              <div class="form-group">
                <label>Send to (up to 5 email addresses)</label>
                <input
                  class="form-control"
                  v-model="text"
                  type="text"
                >
              </div>
            </div>
            <div
              class="col-sm-3"
              style="padding-top:23px;"
            >
              <div class="form-group">
                <button
                  class="btn btn-success"
                  @click="addEmail()"
                >
                  Add Email
                </button>
              </div>
            </div>
          </div>
          <div
            v-if="models.emails.length"
            class="row"
          >
            <div class="col-sm-12">
              <div class="form-group">
                <span
                  v-for="(email, idx) in models.emails"
                  :key="idx"
                  class="emails-label"
                >
                {{ email }}
                &nbsp;
                <span
                  style="cursor: pointer;"
                  @click="deleteEmail(email)"
                >x</span>
              </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Subject</label>
                <input
                  class="form-control"
                  v-model="models.subject"
                  type="text"
                  value=""
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Message</label>
                <textarea
                  class="form-control"
                  v-model="models.message"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            v-if="mode === modalWindowTypes.CREATE"
            class="btn btn-success"
            @click="add()"
          >
            Add
          </button>
          <button
            v-if="mode === modalWindowTypes.EDIT"
            class="btn btn-success"
            @click="save()"
          >
            Save
          </button>
          <button
            class="btn btn-danger"
            @click="close()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  modalWindowTypes
} from '@/utils/dictionaries'

export default {
  name: 'ModalNotification',
  props: {
    model: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: modalWindowTypes.CREATE
    }
  },
  data: () => (
    {
      text: '',
      emailsCounter: 5,
      models: {
        fromName: '',
        fromEmail: '',
        emails: [],
        subject: '',
        message: ''
      }
    }
  ),
  computed: {
    modalWindowTypes() {
      return modalWindowTypes
    }
  },
  mounted() {
    if (this.model !== null) {
      this.updateData()
    }
  },
  methods: {
    addEmail() {
      if (this.text.length > 5 && this.models.emails.length < this.emailsCounter) {
        this.models.emails.push(this.text)
        this.text = ''
      }
    },
    deleteEmail(email) {
      this.models.emails = this.models.emails.filter(e => e !== email)
    },
    add() {
      this.$emit('add', { ...this.$data.models })
    },
    save() {
      this.$emit('save', { ...this.$data.models })
      this.clearData()
    },
    close() {
      this.$emit('close')
    },
    updateData() {
      for (const key in this.models) {
        this.models[key] = this.model.value[key]
      }
    },
    clearData() {
      this.models.fromName = ''
      this.models.fromEmail = ''
      this.models.emails = []
      this.models.subject = ''
      this.models.message = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.emails-label {
  display: inline-flex;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 10px;
  background: #eee;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalNotification.vue